import React from 'react';
import { useShallow } from 'zustand/react/shallow';

import { ContinueArrowIcon } from '../rosettaSvgs';
import { Button } from '@attentive-platform/stem-ui';
import { useRosettaStore } from '../../../Stores/useRosettaStore';
import { calculateTradePriceForTradeHelper } from '../utils/rosettaPricingHelpers';

const PriceSummaryPanel = () => {
  const { selectedTrades, tradesData, selectedScopes, inflationPercentage, dispatch } = useRosettaStore(
    useShallow(state => ({
      selectedTrades: state.selectedTrades,
      tradesData: state.tradesData,
      selectedScopes: state.selectedScopes,
      inflationPercentage: state.inflationPercentage,
      dispatch: state.dispatch
    }))
  );

  const calculateTradePriceForTrade = tradeId => {
    const trade = tradesData.find(t => t.trade_id === tradeId);
    if (!trade) return 0;

    const selectedScopeIds = Array.from(selectedScopes[tradeId] || []);
    return calculateTradePriceForTradeHelper(trade, selectedScopeIds, inflationPercentage);
  };

  const handleContinueToPricing = () => {
    dispatch({ type: 'SET_SHOW_PRICING', payload: true });
  };

  return (
    <aside className='rosetta-panel'>
      <div className='rosetta-panel-header'>
        <h2>Price Summary</h2>
      </div>
      <div className='rosetta-panel-content'>
        <div className='rosetta-summary-section'>
          <h3 className='rosetta-summary-title'>Price per Trade</h3>
          <div className='rosetta-trade-prices-list'>
            {Array.from(selectedTrades).map(tradeId => {
              const trade = tradesData.find(t => t.trade_id === tradeId);
              const tradePrice = calculateTradePriceForTrade(tradeId);
              return trade ? (
                <div key={tradeId} className='rosetta-trade-price-item'>
                  <span className='rosetta-trade-price-name'>{trade.trade_name}</span>
                  <span className='rosetta-trade-price-value'>${tradePrice.toFixed(1)}/sheet</span>
                </div>
              ) : null;
            })}
            {selectedTrades.size === 0 && <p className='empty-message'>Select trades to see pricing</p>}
          </div>
        </div>

        <div >
          <Button
            variant='contained'
            onClick={handleContinueToPricing}
            disabled={selectedTrades.size === 0}
            size='medium'>
            Continue to Pricing
            <ContinueArrowIcon />
          </Button>
        </div>
      </div>
    </aside>
  );
};

export default PriceSummaryPanel;
